import { createBrowserClient } from '@supabase/ssr';

const PLACEHOLDER_VALUES = [
  'None', 'none', 'undefined', 'null', '',
  'your-supabase-anon-key-here', 'your-supabase-url-here',
  'your-next-public-supabase-url-here', 'your-next-public-supabase-anon-key-here',
];

function isValidValue(value: string | undefined): boolean {
  if (!value) return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (PLACEHOLDER_VALUES.includes(trimmed)) return false;
  return true;
}

function getSupabaseUrl(): string | null {
  // Try all possible env var names Rocket might inject
  const candidates = [
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_PROJECT_URL,
    process.env.SUPABASE_PROJECT_URL,
  ];
  for (const val of candidates) {
    if (isValidValue(val) && val!.trim().startsWith('http')) {
      return val!.trim();
    }
  }
  return null;
}

function getSupabaseAnonKey(): string | null {
  // Try all possible env var names Rocket might inject
  const candidates = [
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    process.env.SUPABASE_ANON_KEY,
    process.env.NEXT_PUBLIC_SUPABASE_KEY,
    process.env.SUPABASE_KEY,
    process.env.NEXT_PUBLIC_SUPABASE_PUBLIC_KEY,
    process.env.SUPABASE_PUBLIC_KEY,
  ];
  for (const val of candidates) {
    if (isValidValue(val) && val!.trim().length > 20) {
      return val!.trim();
    }
  }
  return null;
}

export function isSupabaseConfigured(): boolean {
  return !!(getSupabaseUrl() && getSupabaseAnonKey());
}

export function createClient() {
  const url = getSupabaseUrl();
  const key = getSupabaseAnonKey();

  if (!url || !key) return null;

  try {
    return createBrowserClient(url, key);
  } catch {
    return null;
  }
}
